export * from '../../original/js/components/auto-resize';

// soon to be depricated.
import { AutoResize } from '../../original/js/components/auto-resize';

export default AutoResize;
